import { split } from 'lodash-es';
import {
	PropsWithChildren,
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from 'react';

import AccordionContext from './AccordionContext';
import { AccordionContextProps } from './types';

interface AccordionContainerProps extends PropsWithChildren {
	defaultExpanded?: string;
}

export const AccordionContainer = ({
	children,
	defaultExpanded,
}: AccordionContainerProps) => {
	const [expanded, setExpanded] = useState<
		string | undefined
	> // items names joined with ',' like name1,name2, etc.
	(defaultExpanded);

	useEffect(() => {
		setExpanded(defaultExpanded);
	}, [defaultExpanded]);

	const handleOnChange = useRef((name: string) => {
		setExpanded((current) => (current !== name ? name : undefined));
	});

	const checkIfExpanded = useCallback(
		(name: string) => split(expanded, ',').includes(name),
		[expanded]
	);

	const contextValue: AccordionContextProps = useMemo(
		() => ({
			expanded,
			checkIfExpanded,
			onChange: handleOnChange.current,
		}),
		[checkIfExpanded, expanded]
	);

	return (
		<AccordionContext.Provider value={contextValue}>
			{children}
		</AccordionContext.Provider>
	);
};
